import React from "react"
import EmbeddedRowsCell from "components/grids/EmbeddedRowsCell/EmbeddedRowsCell"
import ActivityCellWithFlag from "./ActivityCellWithFlag/ActivityCellWithFlag"

// types
import type { Assessment, ActivityType } from "../../assessment-types"

type ActivitiesCellRendererProps = {
  data: Assessment
  activityTypes: ActivityType[]
}

const ActivitiesCellRenderer = ({ data, activityTypes }: ActivitiesCellRendererProps) => {
  return (
    <EmbeddedRowsCell>
      {data.attached_projects?.length > 0 ? (
        data.attached_projects.map((activity) => {
          return (
            <EmbeddedRowsCell.Cell key={activity.id}>
              <ActivityCellWithFlag
                data={data} // for recommended types
                activityId={activity.id}
                activityTitle={activity.title}
                activityTypes={activityTypes}
              />
            </EmbeddedRowsCell.Cell>
          )
        })
      ) : (
        // even tho there is no attached project show a row (with a possible recommended activity flag icon)
        <EmbeddedRowsCell.Cell>
          <ActivityCellWithFlag
            data={data} // for recommended types
            activityTypes={activityTypes}
          />
        </EmbeddedRowsCell.Cell>
      )}
    </EmbeddedRowsCell>
  )
}

export default ActivitiesCellRenderer
